export const headerDetails = {
  contactUsCTA: "Kontakta oss",
}
